import icon from "images/icons/icon-issue.svg?raw"
import parse from "html-react-parser"

export default function IssueIcon() {
  return (
    <span className="svg-icon svg-icon-issue">{parse(icon)}</span>
  )
}
